__webpack_require__.p = "https://assets.socrative.com/5.0.6/js/";